import { HEADER_BUTTON_MODE } from '@hqo/hqo-miniapp-client-sdk';
import { useMiniappSdk } from 'components/miniapp-sdk-provider/miniapp-sdk.hook';
import { createElement, useEffect } from 'react';
import useFormatHtmlText from 'shared/hooks/useFormatHtmlText/useFormatHtmlText.hook';
import { useIsSmallViewportWidth } from 'hooks/use-is-small-viewport-width.hook';

export interface MarkdownTextProps {
  children: string;
  element?: string;
}

const HtmlText = ({ children, element = 'div' }: MarkdownTextProps) => {
  const client = useMiniappSdk();
  const isMobileDevice = useIsSmallViewportWidth();

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = (event.target as HTMLElement)?.closest('a');
      if (target) {
        if (isMobileDevice) {
          client?.header.setHeader('', HEADER_BUTTON_MODE.HISTORY);
          client?.header.showHeader();
        }
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [client?.header, isMobileDevice]);

  const html = useFormatHtmlText(children);
  return createElement(element, {
    dangerouslySetInnerHTML: {
      __html: html,
    },
  });
};

export default HtmlText;
